import { FormEvent, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Login() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => event.preventDefault();

  const handleLogin = async () => {
    setMessage(null);
    try {
      await login(email, password);
      setMessage("Signed in. Redirecting...");
      navigate("/dashboard", { replace: true });
    } catch (error) {
      setMessage((error as Error).message);
    }
  };

  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <div className="max-w-md">
      <h2 className="text-2xl font-semibold mb-4 text-slate-900">Login</h2>
      <form
        className="space-y-4 bg-white border border-slate-200 rounded-xl p-5 shadow-sm"
        onSubmit={handleSubmit}
      >
        <div className="space-y-1">
          <label className="text-sm text-slate-700">Email</label>
          <input
            className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
          />
        </div>
        <div className="space-y-1">
          <label className="text-sm text-slate-700">Password</label>
          <input
            className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
          />
        </div>
        <button
          type="button"
          onClick={handleLogin}
          disabled={loading}
          className="w-full bg-brand-primary text-white font-semibold py-2 rounded-md hover:bg-brand-muted transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Login"}
        </button>
        {message && <p className="text-sm text-slate-600">{message}</p>}
      </form>
    </div>
  );
}

export default Login;
